// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5j-6";
export var headerCell = "_5j-2";
export var loadingStateContent = "_5j-8";
export var rowWrapper = "_5j-4";
export var stickyAggregationCell = "_5j-b";
export var stickyAggregationRow = "_5j-7";
export var stickyColumnCell = "_5j-a";
export var stickyColumnHeaderCell = "_5j-9";
export var table = "_5j-1";
export var virtualRowWrapper = "_5j-5";
export var virtualTableContainer = "_5j-0";
export var white = "_5j-3";